import { ChangeDetectionStrategy, Component, computed, forwardRef } from '@angular/core';
import { NodeViewComponent } from '@examdojo/core/tiptap';
import {
  WidgetComponent as CoreWidgetComponent,
  WidgetComponentConfig,
  WidgetOrchestratorService,
} from '@examdojo/core/widget';
import { provideJsxgraphWidgets } from '@examdojo/math-widget';
import { v4 as uuid } from 'uuid';
import { WidgetBlock } from '../../../model';
import { DragWithHandleOnlyDirective } from '../drag-with-handle-only.directive';
import { DEFAULT_WIDGET_PROPS } from './widget.model';

@Component({
  selector: 'dojo-widget-node',
  standalone: true,
  imports: [CoreWidgetComponent],
  templateUrl: './widget.component.html',
  styleUrl: './widget.component.scss',
  hostDirectives: [DragWithHandleOnlyDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    provideJsxgraphWidgets(),
    WidgetOrchestratorService,
    {
      provide: NodeViewComponent,
      useExisting: forwardRef(() => WidgetNodeComponent),
    },
  ],
})
export class WidgetNodeComponent extends NodeViewComponent<WidgetBlock> {
  readonly config = this.getProp('config');

  readonly widgetConfig = computed<WidgetComponentConfig>(() => {
    const config = this.config() as unknown as WidgetComponentConfig | undefined;
    return {
      ...config,
      // Ensure a unique ID for each widget instance
      id: config?.['id'] ?? `widget-${uuid()}`,
    } as WidgetComponentConfig;
  });

  override getDefaults = (): WidgetBlock => ({
    ...DEFAULT_WIDGET_PROPS,
    id: uuid(),
  });
}
